import React, { useMemo, useState, useCallback } from 'react';
import { useSelector } from 'react-redux';
import { Link, useLocation } from 'react-router-dom';
import block from 'bem-cn';
import SVGInline from 'react-svg-inline';

import { rankTypes } from 'features/ranking/data';

import arrowSvg from './img/arrow.svg';

import './ListItem.scss';

const b = block('list-item');

const ListItem = ({ item, changeMenuOpen, isParent = true, onSpecialAction }) => {
  const [isOpened, setOpened] = useState(item.children?.length ? true : null);
  const locale = useSelector(state => state.locale.locale);
  const authData = useSelector(state => state.auth);
  const { withRanking, myRank } = useSelector(state => state.rankings);
  const { isVisible: feedbackLinkVisible } = useSelector(state => state.agentFeedback);
  const location = useLocation();

  const onClick = useCallback(
    e => {
      if (item?.isSpecialAction && onSpecialAction) {
        e.preventDefault();
        onSpecialAction();
        return;
      }

      if (item?.children) {
        if (isOpened === null) {
          setOpened(true);
        } else {
          setOpened(prevState => !prevState);
        }
      }

      if (!isParent) changeMenuOpen(false);
    },
    [isOpened, item, changeMenuOpen, isParent, onSpecialAction],
  );

  const childrens = useMemo(
    () =>
      item.children?.map(el => (
        <ListItem
          item={el}
          key={el.title}
          isParent={false}
          changeMenuOpen={changeMenuOpen}
          onSpecialAction={onSpecialAction}
        />
      )) || [],
    [item, changeMenuOpen, onSpecialAction],
  );

  const isActive = item.isSpecialAction
    ? true
    : item.withParams
    ? location.pathname.startsWith(item.routeForActiveTab)
    : location.pathname === item.routeForActiveTab;

  const isAllowed = item.checkAccess ? item.checkAccess(authData) : true;
  if (!isAllowed) return null;
  if (item.route === '/ranking' && !withRanking) return null;
  if (item.isSpecialAction && !feedbackLinkVisible) return null;

  const title = () => {
    if (item.title === 'ranking' && myRank?.rank === rankTypes.silver) {
      return locale.rankingAdministration;
    }
    if (item.title === 'ranking' && myRank?.rank === rankTypes.providerSilver) {
      return `${locale.tournamentOf}${locale.rankings[rankTypes.providerSilver]}`;
    }
    if (item.title === 'ranking' && myRank?.rank === rankTypes.providerGold) {
      return `${locale.tournamentOf}${locale.rankings[rankTypes.providerGold]}`;
    }
    return locale[item.title] || item.title;
  };
  
  return (
    <div className={b({ active: isActive })}>
      <Link to={item.route} className={b('parent', { level: item.level })} onClick={onClick}>
        <div className={b('parent', 'td')}>
          {item.img && item.whiteImg && (
            <SVGInline svg={isActive ? item.whiteImg : item.img} className={b('parent', 'img-icon').toString()} />
          )}
          <span className={b('parent', 'title')}>{title()}</span>
        </div>

        {item?.children && (
          <SVGInline svg={arrowSvg} className={b('parent', 'img-arrow', { opened: isOpened }).toString()} />
        )}
        {Boolean(item.count) && <span className={b('parent', 'count')}>{item.count <= 9 ? item.count : 'N'}</span>}
      </Link>
      {isOpened && <div className={b('children')}>{childrens}</div>}
    </div>
  );
};

export default ListItem;
